var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.9,
    height: 42.3,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 42.3v-3a17.208 17.208 0 0 0 3.45-.975A14.3 14.3 0 0 0 27 36.45l2.15 2.2a18.536 18.536 0 0 1-4.25 2.4 20.406 20.406 0 0 1-4.65 1.25Zm-4.5 0a18.275 18.275 0 0 1-11.3-6.1A17.615 17.615 0 0 1 0 24.15a17.682 17.682 0 0 1 1.4-7.025 17.95 17.95 0 0 1 9.575-9.575A17.682 17.682 0 0 1 18 6.15h1L15.05 2.2l2.2-2.2 7.65 7.65-7.65 7.65-2.2-2.2L19 9.15h-1a14.773 14.773 0 0 0-15 15 14.589 14.589 0 0 0 3.625 9.975A15.735 15.735 0 0 0 15.75 39.3Zm16.55-6.8-2.2-2.2a13.013 13.013 0 0 0 1.825-3.25 15.85 15.85 0 0 0 .925-3.65h3.05a20.779 20.779 0 0 1-1.275 4.875A18.8 18.8 0 0 1 32.3 35.5Zm3.6-13.6h-3.05A16 16 0 0 0 30.1 15l2.2-2.15a19.442 19.442 0 0 1 2.35 4.275A20.752 20.752 0 0 1 35.9 21.9Z",
    fill: "#fafafa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/rotate_right_.21ebb1d2a24aa012359e49e0d03ff216.svg";
export { ForwardRef as ReactComponent };